import React, { useEffect, useRef, useState } from "react";
import { Reader } from "@usewaypoint/email-builder";
import {useManagerContext} from "../../../sections/emails/ManagerContext";

export const PreviewPanel = ({ document }) => {
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState("0px");
    const [iframeReady, setIframeReady] = useState(false);
    const {email} = useManagerContext();

    useEffect(() => {
        const iframe = iframeRef.current;

        if (iframe && email?.content?.html) {
            const doc = iframe.contentDocument || iframe.contentWindow.document;

            if (doc) {
                doc.open();
                doc.write(email.content.html);
                doc.close();

                const resizeObserver = new ResizeObserver(() => {
                    const newHeight = doc.body.scrollHeight;
                    setIframeHeight(`${newHeight}px`);
                });

                iframe.onload = () => {
                    resizeObserver.observe(doc.body);
                    setIframeReady(true);
                };


                return () => {
                    resizeObserver.disconnect();
                };
            }
        }
    }, [email?.content?.html]);

    return (
        <>
            {!email?.content?.html && <Reader document={document} rootBlockId="root" />}
            {email?.content?.html && (
                <div style={{position: 'relative'}}>
                    {iframeReady && (
                        <div className="preview-alert">
                            <strong>⚠️ Custom HTML enabled</strong>
                            <p>You are viewing the custom HTML version of this email because you have added content in the Custom HTML tab.</p>
                            <p>If you want to preview the layout generated by the visual editor, delete the custom content and save your changes.</p>
                        </div>
                    )}
                    <iframe
                        ref={iframeRef}
                        title="Email Preview"
                        style={{
                            width   : "100%",
                            height  : iframeHeight,
                            border  : "none",
                            display : "block",
                            overflow: "hidden",
                        }}
                        scrolling="no"
                    />
                </div>
            )}
        </>
    );
};
